import {
  useUnifiedContractClauseCategories,
  useUnifiedContractClauses,
} from '@/hooks/useUnifiedContractClauses';
import { ClauseCategory } from '@/utils/clauseMapping';

/**
 * Seller contract clauses hook - now uses unified system
 * This ensures sellers see the same contract data as agents
 */
export const useSellerContractClauses = (contractId: string) => {
  return useUnifiedContractClauses(contractId);
};

/**
 * Enhanced seller contract clause categories hook
 * Returns the full clause category structure with hierarchical IDs
 */
export const useSellerContractClauseCategories = (
  contractId: string
): ClauseCategory[] => {
  return useUnifiedContractClauseCategories(contractId);
};
